export default __webpack_public_path__ + "static/tag-dont-5-dark-7d08d73071c53c410ba5e035449b13897875a38a2c0d6fac1ae03118b94ddc6b.png";